<template>
  <div>
    <el-form
      :model="formData"
      :rules="rules"
      ref="form"
      class="main-form-scroll"
    >
      <el-form-item :label="$t('role.value')" prop="nameSelected">
        <el-input v-model="formData.nameSelected"></el-input>
      </el-form-item>
      <el-form-item prop="specialUserChecked">
        <el-checkbox v-model="formData.specialUserChecked">{{
          $t("role.specialUserChecked")
        }}</el-checkbox>
      </el-form-item>
    </el-form>
    <div slot="footer" class="bottom-buttons">
      <div></div>
      <div>
        <el-button class="button-cancel" type="plain" @click="cancelClick"
          >{{ $t("role.cancel") }}
        </el-button>
        <el-button class="button-confirm" type="success" @click="okClick"
          >OK</el-button
        >
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  props: {
    type: String,
  },
  data() {
    return {
      formData: {
        nameSelected: null,
        specialUserChecked: false,
      },
      rules: {
        nameSelected: [
          {
            required: true,
            message: this.$t("role.enterRoleName"),
            trigger: "blur",
          },
        ],
        specialUserChecked: [{ required: false }],
      },
    };
  },
  methods: {
    populateForm() {
      this.formData.nameSelected = this.getCurInfo.name;
      this.formData.specialUserChecked =
        this.getCurInfo.type === "0" ? false : true;
    },
    okClick() {
      if (!!this.formData.nameSelected)
        this.formData.nameSelected = this.formData.nameSelected.trim();
      this.$refs["form"].validate((valid, object) => {
        if (valid) {
          this.$emit("data", this.formData);
        } else {
          this.$message.error(this.$t("errors.notAllRequiredFieldsSelected"));
        }
      });
    },
    cancelClick() {
      this.$emit("close");
    },
  },
  computed: {
    ...mapGetters(["getCurInfo"]),
  },
  created() {
    if (this.type === "edit") {
      this.populateForm();
    }
  },
};
</script>

